// Content filtering utility

const BANNED_WORDS = [
  'kill', 'suicide', 'prank', 'sex', 'anal', 'rape', 'fuck', 'shit', 'piss',
  'undead', 'satan', 'killer', 'stab', 'gun', 'shoot', 'drug', 'cigarette',
  'weed', 'marijuana', 'pill'
];

const ALLOWED_CHARS_PATTERN = /^[a-zA-Z0-9\s,.!;-]*$/;

/**
 * Validate text content for banned words and allowed characters
 * @param {string} text - Text to validate
 * @param {string} fieldName - Name of the field for error messages
 * @returns {object} - { isValid: boolean, error: string | null }
 */
export const validateContent = (text, fieldName = 'Text') => {
  if (!text) {
    return { isValid: true, error: null };
  }

  // Check allowed characters
  if (!ALLOWED_CHARS_PATTERN.test(text)) {
    return {
      isValid: false,
      error: `${fieldName} contains invalid characters. Only letters, numbers, and ,.!- are allowed.`
    };
  }

  // Check banned words (case-insensitive, whole word matches)
  const textLower = text.toLowerCase();
  for (const bannedWord of BANNED_WORDS) {
    const regex = new RegExp(`\\b${bannedWord}\\b`, 'i');
    if (regex.test(textLower)) {
      return {
        isValid: false,
        error: `${fieldName} contains inappropriate content. Please revise and try again.`
      };
    }
  }

  return { isValid: true, error: null };
};

/**
 * Validate content and show toast error if invalid
 * @param {string} text - Text to validate
 * @param {string} fieldName - Name of the field for error messages
 * @param {function} toast - Toast function from sonner
 * @returns {boolean} - true if valid, false if invalid
 */
export const validateAndShowError = (text, fieldName, toast) => {
  const { isValid, error } = validateContent(text, fieldName);
  if (!isValid) {
    toast.error(error);
  }
  return isValid;
};
